// DS: CR18E
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import get from 'lodash/get';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import AddToFaveIcon from '@wix/da-ds/pkg/Icons/24x24/AddedToFav';
import RemoveFaveIcon from '@wix/da-ds/pkg/Icons/24x24/RemovedFromFav';
import ErrorIcon from '@wix/da-ds/pkg/Icons/CloseBold';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import { ActionBarContext } from '../../ActionBar/ActionBarContext';
import { BiData } from '@wix/da-bi/pkg/events';
const FaveNotification = (props)=>{
    const { success, id, type, isFavourite, deviation, queueName, addNotification, removeNotification, onAddToCollection, currentUser } = props;
    const { t } = useTranslation();
    const actionBarType = useContext(ActionBarContext);
    const deviationBiData = {
        itemid: deviation.deviationId,
        typeid: getDeviationResourceType(deviation),
        creatorid: get(deviation, 'author.useridUuid')
    };
    const renderTitle = ()=>{
        const wasRemoved = isUndo() || !isFavourite;
        if (!success) {
            return t(`faveNotification.error.${wasRemoved ? 'removedFromFaves' : 'addedToFaves'}.v2`);
        }
        if (wasRemoved) {
            return(// prettier-ignore
            /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: "faveNotification.notification.removedFromFaves.v2"
            }, "Removed from ", /*#__PURE__*/ React.createElement("a", {
                href: Url.userGalleryLink({
                    username: currentUser.username,
                    gallectionType: 'collection'
                })
            }, "Favourites")));
        }
        return(// prettier-ignore
        /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: "faveNotification.notification.addedToFaves.v2"
        }, "Added to ", /*#__PURE__*/ React.createElement("a", {
            href: Url.userGalleryLink({
                username: currentUser.username,
                gallectionType: 'collection'
            })
        }, "Favourites")));
    };
    const isUndo = ()=>{
        return type === NotificationType.FaveUndo;
    };
    const onCollect = ()=>{
        onAddToCollection && onAddToCollection(deviation, queueName, actionBarType);
        removeNotification(id);
    };
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: {
            iconComponent: success ? isUndo() || !isFavourite ? RemoveFaveIcon : AddToFaveIcon : ErrorIcon,
            backgroundDeviation: deviation,
            actions: [
                !isUndo() && isFavourite && {
                    type: 'positive',
                    label: t('faveNotification.notification.action.addToCollection'),
                    biData: BiData(_object_spread({
                        evid: 333,
                        sectionname: 'notificationTooltip'
                    }, deviationBiData)),
                    onClick: onCollect
                }
            ]
        },
        onClose: queueName === getDeviationNotificationQueue(deviation) && success && isFavourite && !isUndo() ? ()=>addNotification(queueName, 'commentReminder', {}) : undefined
    }, /*#__PURE__*/ React.createElement("span", null, renderTitle()));
};
FaveNotification.displayName = 'FaveNotification';
export default FaveNotification;
